"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHasBusinessLoansLoadedSuccessfully = exports.getHasABusinessLoansFetchFinished = exports.getBusinessLoansSlice = exports.getBusinessLoansLastSuccess = exports.getBusinessLoansLastError = exports.getBusinessLoansError = exports.getBusinessLoansData = exports.getBusinessLoans = exports.getAreBusinessLoansLoading = exports["default"] = exports.businessLoans = void 0;

var _reselect = require("reselect");

var _utils = require("@navinc/utils");

var _actions = require("./actions");

var _lodash = _interopRequireDefault(require("lodash.get"));

var _updatePlsUrlLoggedOut = require("../util/update-pls-url-logged-out");

var businessLoans = (0, _utils.createFetchReducer)({
  loadActionType: _actions.BUSINESS_LOANS_LOAD,
  failureActionType: _actions.BUSINESS_LOANS_FAILURE,
  successActionType: _actions.BUSINESS_LOANS_SUCCESS
});
exports.businessLoans = businessLoans;

var _default = function _default(state, action) {
  switch (action.type) {
    case _actions.BUSINESS_LOANS_LOAD:
    case _actions.BUSINESS_LOANS_FAILURE:
    case _actions.BUSINESS_LOANS_SUCCESS:
      {
        var newBusinessLoan = businessLoans(state.businessLoans, action);
        return state.businessLoans === newBusinessLoan ? state : {
          businessLoans: newBusinessLoan
        };
      }

    default:
      {
        return state;
      }
  }
};

exports["default"] = _default;

var _createBaseSelectors = (0, _utils.createBaseSelectors)('businessLoans'),
    getBusinessLoansSlice = _createBaseSelectors.getSlice,
    getAreBusinessLoansLoading = _createBaseSelectors.getIsLoading,
    getBusinessLoansLastError = _createBaseSelectors.getLastError,
    getBusinessLoansLastSuccess = _createBaseSelectors.getLastSuccess,
    getBusinessLoansDataRaw = _createBaseSelectors.getData,
    getBusinessLoansError = _createBaseSelectors.getError,
    getHasABusinessLoansFetchFinished = _createBaseSelectors.getHasAFetchFinished,
    getHasBusinessLoansLoadedSuccessfully = _createBaseSelectors.getHasLoadedSuccessfully;

exports.getHasBusinessLoansLoadedSuccessfully = getHasBusinessLoansLoadedSuccessfully;
exports.getHasABusinessLoansFetchFinished = getHasABusinessLoansFetchFinished;
exports.getBusinessLoansError = getBusinessLoansError;
exports.getBusinessLoansLastSuccess = getBusinessLoansLastSuccess;
exports.getBusinessLoansLastError = getBusinessLoansLastError;
exports.getAreBusinessLoansLoading = getAreBusinessLoansLoading;
exports.getBusinessLoansSlice = getBusinessLoansSlice;
var getBusinessLoansData = (0, _reselect.createSelector)(getBusinessLoansDataRaw, function (data) {
  var _data$businessLoans;

  if (!data) {
    return data;
  }

  return Object.assign({}, data, {
    businessLoans: (_data$businessLoans = data.businessLoans) === null || _data$businessLoans === void 0 ? void 0 : _data$businessLoans.map(function (loan) {
      return Object.assign({}, loan, {
        applyUrl: (0, _updatePlsUrlLoggedOut.updatePLSUrlLoggedOut)(loan.applyUrl)
      });
    })
  });
});
exports.getBusinessLoansData = getBusinessLoansData;
var getBusinessLoans = (0, _reselect.createSelector)(getBusinessLoansData, function (businessLoans) {
  return (0, _lodash["default"])(businessLoans, 'businessLoans', []);
});
exports.getBusinessLoans = getBusinessLoans;
//# sourceMappingURL=reducer.js.map